import { isString, toLower } from 'lodash-es';

import { validString } from './types.utils';

export function returnOrDefaultString(...params: string[]): string {
	const found = params.find(validString);

	return found || '';
}

/**
 * Uses just alphanumeric characters.
 * @param str The string to use
 */
export function normalize(str: any) {
	if (isString(str)) {
		return toLower(str.replace(/[^\w\d]/g, ''));
	}
	return '';
}

/**
 * Joins multiple strings by a separator
 * @param separator The separator to join them by
 * @param args An array of strings. The last property is the separator.
 */
export function joinStrings(separator: string, ...args: string[]): string {
	return args.filter(validString).join(separator);
}

/**
 * Takes the image filename, trims off the extension, and returns the rest of the name with spaces in place of periods
 * @param logo the logo image filename
 * @private
 */
export function parseFilenameForAltText(logo: string): string {
	let logoParts = logo.split('.');
	logoParts = logoParts.splice(0, logoParts?.length - 1);
	return logoParts.join(' ');
}
